import { cva, VariantProps } from 'class-variance-authority'

export type PersonSelectFilterTriggerStyling = VariantProps<typeof personSelectFilterTriggerStyling>

export const personSelectFilterTriggerStyling = cva('flex items-center rounded-pill border border-border w-full sm:w-44 overflow-hidden h-fit p-stack-dense', {
  variants: {
    size: {
      sm: 'h-fit',
      md: 'h-fit',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type PersonSelectFilterIconStyling = VariantProps<typeof personSelectFilterIconStyling>

export const personSelectFilterIconStyling = cva('flex items-center rounded-pill bg-surface-muted', {
  variants: {
    size: {
      sm: 'p-stack-tight',
      md: 'p-stack-tight',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type PersonSelectFilterTextStyling = VariantProps<typeof personSelectFilterTextStyling>

export const personSelectFilterTextStyling = cva('h-full flex items-center text-fg-muted w-full gap-stack-dense', {
  variants: {
    size: {
      sm: 'p-stack-dense text-xs',
      md: 'p-stack-dense text-sm',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
